// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43335030","239":"e2a2512e","453":"ed05a072","455":"9459d813"}[chunkId] + ".chunk.js";
};